import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Spinner } from '@treams/treams-ui';

import TalentReview from './TalentReview';
import TalentReviewSharedPage from './TalentReviewSharedPage';

export default function TalentReviewSnapshotPage(props: { snapshotID: string }) {
	const location = useLocation();
	const manage = new URLSearchParams(location.search).get('manage') === '1';
	const query = graphql.useTalentReviewSnapshotQuery({
		variables: { id: props.snapshotID, manage },
	});

	const snapshot = query.data?.talentReviewSnapshot;

	if (!snapshot) {
		return (
			<Flex my={5} justifyContent="center">
				<Spinner />
			</Flex>
		);
	}

	// The email link has no manage flag, so a manager sees the same personal
	// page as everyone else. The date list on the working grid sets the flag
	// and opens the submitted grid, also for managers of a department above
	// the group, who may only read it.
	if (manage && snapshot.group.viewerCanViewTalentReviews) {
		return (
			<TalentReview
				embedded
				templateID={snapshot.template.id}
				groupID={snapshot.group.id}
				localDate={snapshot.localDate}
				grid={
					{
						localDate: snapshot.localDate,
						viewerCanUpdate: false,
						template: snapshot.template,
						group: snapshot.group,
						placements: snapshot.placements,
						activity: snapshot.activity,
					} as graphql.TalentReviewGrid
				}
				snapshot={{
					id: snapshot.id,
					title: snapshot.title,
					description: snapshot.description ?? undefined,
					visibility: snapshot.visibility,
					submittedAt: moment(snapshot.createdAt).format('LL'),
					submittedBy: `${snapshot.createdBy.firstName} ${snapshot.createdBy.lastName}`,
					localDate: moment(snapshot.localDate).format('LL'),
					viewerCanCorrect: snapshot.viewerCanCorrect,
					activity: snapshot.activity,
				}}
			/>
		);
	}

	return <TalentReviewSharedPage snapshot={snapshot} />;
}
